import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { API, Storage }         from "aws-amplify";
import { s3Upload, getS3Attachment } from "../../libs/awsLib";

import '../../css/assessment/InBodyForm.css';

export default class InBodyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initLoadImages: false
        };
    }

    //this.setState({ totalBodyWater: event.target.value });
    handleTotalBodyWaterChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.totalBodyWater(val);
    }
    handleDryLeanMassChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.dryLeanMass(val);
    }
    handleBodyFatMassChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.bodyFatMass(val);
    }
    handlePBFChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.pbf(val);
    }
    handleSMMChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.smm(val);
    }
    handleBMIChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.bmi(val);
    }
    handleWeightChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.weight(val);
    }
    /******* NEW *****/
    handleRightArmChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.rightArm(val);
    }
    handleLeftArmChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.leftArm(val);
    }
    handleTrunkChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.trunk(val);
    }
    handleRightLegChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.rightLeg(val);
    }
    handleLeftLegChange = (event) => {
        var val = event.target.value;
        if (!val || val.match(/^\d{1,}(\.\d{0,4})?$/))
            this.props.leftLeg(val);
    }

    render() {

        return (
            <div style={{float:"left",  width: "100%"}}>
                { /*************************************************/}
                { /********************  ROW 1  ********************/}
                <Row className="grid">
                      <div className="inBodySectionTitle">
                          Body Composition Analysis
                      </div>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <Row className="grid inBodyRowGrayBkgrd">
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Total Body Water
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Body Fat Mass
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Dry Lean Mass
                          </span>
                      </Col>
                </Row>
                <Row className="grid inBodyRowGrayBkgrd">
                        <Col xs={4} sm={4} md={4}>
                            <span>
                                  <input type        = "text"
                                         value       = {this.props.totalBodyWater_val}
                                         onChange    = {this.handleTotalBodyWaterChange.bind(this)}
                                         maxLength   = "6"
                                         className   = "input-lg tf_addExercise tf_short150PxWidth" />
                            </span>
                        </Col>
                      <Col xs={4} sm={4} md={4}>                          
                          <span>
                                <input type        = "text"
                                       value       = {this.props.bodyFatMass_val}
                                       onChange    = {this.handleBodyFatMassChange.bind(this)}
                                       maxLength   = "6"
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.dryLeanMass_val}
                                       onChange    = {this.handleDryLeanMassChange.bind(this)}
                                       maxLength   = "6"
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>

                { /*************************************************/}
                { /********************  ROW 2  ********************/}
                <Row className="grid">
                      <div className="inBodySectionTitle">
                          Muscle Fat Analysis
                      </div>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <Row className="grid">
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              <br/>Weight
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              SMM <br/><span className="formLabelSubTitle">(Skeletal Muscle Mass)</span>
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              <br/>Body Fat Mass
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.weight_val}
                                       maxLength   = "6"
                                       onChange    = {this.handleWeightChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.smm_val}
                                       maxLength   = "6"
                                       onChange    = {this.handleSMMChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.bodyFatMass_val}
                                       onChange    = {this.handleBodyFatMassChange.bind(this)}
                                       maxLength   = "6"
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>

                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                { /*************************************************/}
                { /********************  ROW 3  ********************/}
                <Row className="grid">
                      <div className="inBodySectionTitle">
                          Obesity Analysis
                      </div>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <Row className="grid">
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              BMI <br/><span className="formLabelSubTitle">(Body Mass Index)</span>
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              PBF<br/><span className="formLabelSubTitle">(% Body Fat)</span>
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">

                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                        <Col xs={4} sm={4} md={4}>
                            <span>
                                  <input type        = "text"
                                         value       = {this.props.bmi_val}
                                         maxLength   = "6"
                                         onChange    = {this.handleBMIChange.bind(this)}
                                         className   = "input-lg tf_addExercise tf_short150PxWidth" />
                            </span>
                        </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.pbf_val}
                                       maxLength   = "6"
                                       onChange    = {this.handlePBFChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>

                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                { /*************************************************/}
                { /********************  ROW 3  ********************/}
                <Row className="grid">
                      <div className="inBodySectionTitle">
                          Segmental Lean Analysis
                      </div>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <Row className="grid">
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Right Arm
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Left Arm
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Trunk
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                        <Col xs={4} sm={4} md={4}>
                            <span>
                                  <input type        = "text"
                                         value       = {this.props.rightArm_val}
                                         maxLength   = "6"
                                         onChange    = {this.handleRightArmChange.bind(this)}
                                         className   = "input-lg tf_addExercise tf_short150PxWidth" />
                            </span>
                        </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.leftArm_val}
                                       maxLength   = "6"
                                       onChange    = {this.handleLeftArmChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.trunk_val}
                                       maxLength   = "6"
                                       onChange    = {this.handleTrunkChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                { /*************************************************/}
                { /********************  ROW 4  ********************/}
                <Row className="grid">
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Right Leg
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span className="formLabel formLabelInBodyForm">
                              Left Leg
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>

                      </Col>
                </Row>
                <Row className="grid">
                        <Col xs={4} sm={4} md={4}>
                            <span>
                                  <input type        = "text"
                                         value       = {this.props.rightLeg_val}
                                         maxLength   = "6"
                                         onChange    = {this.handleRightLegChange.bind(this)}
                                         className   = "input-lg tf_addExercise tf_short150PxWidth" />
                            </span>
                        </Col>
                      <Col xs={4} sm={4} md={4}>
                          <span>
                                <input type        = "text"
                                       value       = {this.props.leftLeg_val}
                                       maxLength   = "6"
                                       onChange    = {this.handleLeftLegChange.bind(this)}
                                       className   = "input-lg tf_addExercise tf_short150PxWidth" />
                          </span>
                      </Col>
                      <Col xs={4} sm={4} md={4}>

                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <div className="iconAddExercise25pxVertSpacer"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/InBodyForm.js